// OKR dashboard: /okr/admin trong system (nhập liệu) và SPA đọc trên okrspn.com — components/okr/*
// dùng chung cho cả hai, routes/okr-admin-* chỉ ở system.
export const okr: Record<string, string> = {
  'nav.okrAdmin': 'Quản lý OKR',
  // Hiện dưới ô tiêu đề/mô tả kỳ — công khai trên okrspn.com, không có ô nào khác để ghi số.
  'okr.publicTitleHint': 'Tiêu đề/mô tả/sứ mệnh/tầm nhìn hiện công khai cho mọi nhân viên trên okrspn.com — không ghi số tuyệt đối.',
  // components/okr/okr-dashboard.tsx — dùng chung giữa /okr/admin và SPA okrspn.com
  'okr.estimated': 'Tạm tính',
  'okr.revenue': 'Doanh thu',
  'okr.year': 'Cả năm',
  'okr.noKeyResults': 'Chưa có KR nào.',
  'okr.role.cto': 'CTO',
  'okr.role.cmo': 'CMO',
  'okr.role.hrLead': 'HR Lead',
  'okr.role.designLead': 'Design Lead',
  'okr.role.monetLead': 'Monet Lead',
  'okr.role.admin': 'Admin',
  'okr.updatedOn': 'Cập nhật {date} bởi {role}',
  // components/okr/okr-dashboard-*.tsx — chữ trang trí (chú thích viết tay, nhãn, dải cuối trang)
  'okr.dash.heroLabel': 'Sứ mệnh và tầm nhìn công ty',
  'okr.dash.mission': 'Sứ mệnh',
  'okr.dash.mainGoal': 'Main Goal',
  'okr.dash.vision': 'Tầm nhìn',
  'okr.dash.footerSlogan': 'Bước nhỏ, tác động lớn',
  'okr.dash.greaterSuccess': 'Thành công lớn hơn',
  'okr.dash.quarterTabs': 'Các quý',
  'okr.dash.goalsHeading': 'Mục tiêu',
  'okr.dash.allGoals': 'Tất cả',
  'okr.dash.noObjectives': 'Chưa có Objective nào.',
  // routes/okr-admin-page.tsx
  'okr.tab.cycles': 'Kỳ',
  'okr.tab.goal': 'Goal',
  'okr.tab.okr': 'OKR',
  'okr.tab.preview': 'Xem trước',
  'okr.noCycle': 'Chưa có kỳ OKR nào. Vào tab Kỳ để tạo.',
  'okr.cycleSelect': 'Kỳ',
  // routes/okr-admin-cycles-tab.tsx
  'okr.cycles.createTitle': 'Tạo kỳ mới',
  'okr.cycles.year': 'Năm',
  'okr.cycles.titleVi': 'Tiêu đề (VI)',
  'okr.cycles.titleEn': 'Tiêu đề (EN)',
  'okr.cycles.subtitleVi': 'Mô tả (VI)',
  'okr.cycles.subtitleEn': 'Mô tả (EN)',
  'okr.cycles.missionVi': 'Sứ mệnh (VI)',
  'okr.cycles.missionEn': 'Sứ mệnh (EN)',
  'okr.cycles.visionVi': 'Tầm nhìn (VI)',
  'okr.cycles.visionEn': 'Tầm nhìn (EN)',
  'okr.cycles.missionVisionHint': 'Để trống sẽ dùng lại Tiêu đề/Mô tả cho Sứ mệnh/Tầm nhìn.',
  'okr.cycles.create': 'Tạo kỳ',
  'okr.cycles.list': 'Các kỳ đã tạo',
  'okr.cycles.status': 'Trạng thái',
  'okr.cycles.status.open': 'Đang mở',
  'okr.cycles.status.closed': 'Đã chốt',
  'okr.cycles.close': 'Chốt kỳ',
  'okr.cycles.closeConfirmTitle': 'Chốt kỳ {year}?',
  'okr.cycles.closeConfirmMessage': 'Các số đang đánh dấu "tạm tính" sẽ bị đóng băng đúng như hiện tại, không tự cập nhật lại sau này. Kỳ vẫn có thể mở lại sau, nhưng snapshot đã chốt sẽ mất.',
  'okr.cycles.closeConfirmTypeYear': 'Gõ lại {year} để xác nhận',
  'okr.cycles.closedEstimatedWarning': 'Kỳ đã chốt, nhưng một vài số vẫn đang "tạm tính" lúc chốt — số đã đóng băng đúng như lúc đó, có thể khác số cuối cùng sau này.',
  // Dùng cả ở bảng kỳ (okr-admin-cycles-tab.tsx) lẫn badge trên dashboard (components/okr/okr-dashboard.tsx).
  'okr.cycles.closedOn': 'Đã chốt {date}',
  'okr.cycles.reopen': 'Mở lại',
  'okr.cycles.reopenConfirmTitle': 'Mở lại kỳ này?',
  'okr.cycles.reopenConfirmMessage': 'Bản chốt hiện tại của kỳ {year} sẽ được lưu vào lịch sử và kỳ mở lại để sửa.',
  'okr.form.err.titleVi': 'Cần tiêu đề tiếng Việt.',
  'okr.form.err.titleEn': 'Cần tiêu đề tiếng Anh.',
  'okr.form.err.subtitlePair': 'Điền mô tả cả hai thứ tiếng, hoặc để trống cả hai.',
  'okr.form.err.missionPair': 'Điền Sứ mệnh cả hai thứ tiếng, hoặc để trống cả hai.',
  'okr.form.err.visionPair': 'Điền Tầm nhìn cả hai thứ tiếng, hoặc để trống cả hai.',
  'okr.form.err.order': 'Thứ tự phải là số nguyên.',
  'okr.kr.form.err.target': 'Mục tiêu phải là một số lớn hơn 0 (ví dụ 24).',
  'okr.cycles.err.year': 'Năm phải có 4 chữ số.',
  'okr.cycles.err.revenueTarget': 'Mục tiêu doanh thu phải là số >= 0, hoặc để trống.',
  'okr.cycles.revenueTargetSaveFailed': 'Đã tạo kỳ {year}, nhưng lưu mục tiêu doanh thu thất bại: {error} — dùng ô Mục tiêu doanh thu ở trên (đổi năm sang {year}) để thử lại.',
  'okr.cycles.edit': 'Sửa',
  'okr.cycles.editClosedHint': 'Kỳ đã chốt — mở lại kỳ để sửa.',
  'okr.cycles.none': 'Chưa có kỳ nào.',
  'okr.cycles.snapshotHistoryTitle': 'Bản chốt trước:',
  'okr.cycles.snapshotHistoryEntry': 'Chốt {frozenDate} · Mở lại {reopenedDate} bởi {email}',
  // routes/okr-admin-goal-tab.tsx — OKR admin only
  'okr.goal.adminOnlyHint': 'Chỉ OKR admin mới quản lý được Goal.',
  'okr.goal.add': '+ Thêm Goal',
  'okr.goal.edit': 'Sửa',
  'okr.goal.delete': 'Xoá',
  'okr.goal.none': 'Chưa có Goal nào cho kỳ này.',
  'okr.goal.deleteConfirmTitle': 'Xoá Goal này?',
  'okr.goal.deleteConfirmMessage': 'Chỉ xoá được khi không còn Objective nào gắn với Goal này.',
  'okr.goal.form.titleVi': 'Tên Goal (VI)',
  'okr.goal.form.titleEn': 'Tên Goal (EN)',
  'okr.goal.form.icon': 'Icon',
  'okr.goal.form.order': 'Thứ tự',
  // routes/okr-admin-okr-tab.tsx — team → quý → Objective → KR
  'okr.okr.quarterSelect': 'Quý',
  'okr.obj.add': '+ Thêm Objective',
  'okr.obj.edit': 'Sửa',
  'okr.obj.delete': 'Xoá',
  'okr.obj.none': 'Chưa có Objective nào cho team/quý này.',
  'okr.obj.capReached': 'Đã đạt tối đa 3 Objective cho team này trong quý.',
  'okr.obj.deleteConfirmTitle': 'Xoá Objective này?',
  'okr.obj.deleteConfirmMessage': 'Toàn bộ KR và lịch sử check-in bên trong sẽ mất theo. Không thể hoàn tác.',
  'okr.obj.form.titleVi': 'Tên Objective (VI)',
  'okr.obj.form.titleEn': 'Tên Objective (EN)',
  'okr.obj.form.goal': 'Goal',
  'okr.obj.krCapReached': 'Đã đạt tối đa 2 KR cho Objective này.',
  // routes/okr-admin-okr-tab.tsx (KR trong Objective)
  'okr.kr.add': '+ Thêm KR',
  'okr.kr.edit': 'Sửa',
  'okr.kr.delete': 'Xoá',
  'okr.kr.checkin': 'Check-in',
  'okr.kr.readOnly': 'Chỉ xem — bạn không quản lý team này.',
  'okr.kr.none': 'Chưa có KR nào cho Objective này.',
  'okr.kr.form.titleVi': 'Tiêu đề (VI)',
  'okr.kr.form.titleEn': 'Tiêu đề (EN)',
  // Nhắc rõ tên ô để dùng thay vì ghi số vào tiêu đề — trỏ đúng nhãn field bên dưới.
  'okr.kr.form.titleHint': 'Tiêu đề hiện công khai cho mọi nhân viên trên okrspn.com — không ghi số tuyệt đối, dùng ô "Mục tiêu quý này".',
  'okr.kr.form.icon': 'Icon',
  'okr.kr.form.unit': 'Đơn vị',
  'okr.kr.form.target': 'Mục tiêu quý này',
  'okr.kr.form.order': 'Thứ tự',
  'okr.kr.unit.percent': '% (mức đạt được)',
  'okr.kr.unit.count': 'Số lượng',
  'okr.kr.unit.usd': 'USD',
  'okr.kr.deleteConfirmTitle': 'Xoá KR này?',
  'okr.kr.deleteConfirmMessage': 'Toàn bộ lịch sử check-in của KR sẽ mất theo. Không thể hoàn tác.',
  'okr.kr.unitChangeConfirmTitle': 'Đổi đơn vị hoặc mục tiêu?',
  'okr.kr.unitChangeConfirmMessage': 'KR này đã có check-in. Đổi đơn vị/mục tiêu sẽ làm % đã ghi trước đó không còn đúng ý nghĩa cũ.',
  // routes/okr-checkin-modal.tsx
  'okr.checkin.title': 'Check-in KR',
  'okr.checkin.valueLevel': 'Giá trị hiện tại',
  'okr.checkin.valueQuarter': 'Số của quý này',
  'okr.checkin.note': 'Ghi chú',
  'okr.checkin.save': 'Lưu check-in',
  'okr.checkin.history': 'Lịch sử check-in',
  'okr.checkin.historyEmpty': 'Chưa có check-in nào.',
  'okr.checkin.notStarted': 'Quý của Objective này chưa bắt đầu — chưa thể check-in.',
  // SPA okrspn.com — okr/okr-login-page.tsx, okr/okr-dashboard-page.tsx
  'okrspn.login.errorLocked': 'Tài khoản này không đăng nhập được vào okrspn.com',
  'okrspn.login.errorGeneric': 'Đăng nhập thất bại. Vui lòng thử lại.',
  'okrspn.noCycle': 'Chưa có kỳ OKR nào được công bố.',
  'okrspn.signOut': 'Thoát',
  'okrspn.themeToggle': 'Đổi giao diện sáng/tối',
}
